import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import * as settingsAction from "store/entities/settingsInfo/action";

import { ReactComponent as EyeMasked } from "assets/images/icons/project-icons/eye-masked.svg"
import { ReactComponent as EyeRevealed } from "assets/images/icons/project-icons/eye-revealed.svg"
import FormDrawer from "components/__new/common/form-drawer";
import { ButtonLoader, Input } from "components/__new/common/form";
import validate from "utils/validate";
import { message } from 'data/toast';


const ChangePasswordModal = (props) => {
const dispatch = useDispatch();
const {isOpen, setIsOpen} = props;
const {PASSWORD_UPDATED} = message

const [showPassword, setShowPassword] = useState(false);
const [form, setForm] = useState({
    currentPassword: '',
    password: '',
    confirmPassword: '',
});

const { changePasswordLoading, changePassword } = useSelector((state) => state.entities.settingsInfo);
const [isPasswordChanged, setIsPasswordChanged] = useState(false)

const handleChangePassword = (e) => {
    const { name, value } = e.target;
    setForm(prevForm => ({
        ...prevForm,
        [name]: value
    }));
    
    
}

const submitForm = async (e) => { 
    e.preventDefault()
    
    const errors = validate(form);
    if (errors){
        for (var x in errors) {
            toast.error(errors[x]);
        };
        return;
    }
    else{
        const {currentPassword, password} = form
        const params = {
            oldPassword: currentPassword,
            newPassword: password
        }
        dispatch(settingsAction.changePassword(params));
        setIsPasswordChanged(true)
        
    }
 }
 
 useEffect(() => {
    if(changePassword?.message === "Password changed successfully" && isPasswordChanged){
        
        toast.success(changePassword?.message || PASSWORD_UPDATED)
        setIsPasswordChanged(false)
        setIsOpen(false);
        setForm({
            currentPassword: '',
                password: '',
                confirmPassword: '',
        })
    }
   //eslint-disable-next-line 
 }, [changePassword]);

    return (
            <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={setIsOpen}>
                <form onSubmit={submitForm} className="p-6">
                    <FormDrawer.Title
                        title="Change Password"
                        description="Setup a stronger login password"
                        showCloseButton={true}
                        close={setIsOpen}
            />
            
                <hr />
            
                <div className='py-4 text-ep-gray-700'>
                    <Input
                        type={showPassword ? "text" : "password"}
                        autoComplete="false"
                        label="Old Password"
                        placeholder=""
                        rightIcon={showPassword ? <EyeRevealed /> :  <EyeMasked />}
                        rightIconClicked={() => setShowPassword(!showPassword)}
                        rightIconClass="px-3"
                        name="currentPassword"
                        value={form.currentPassword}
                        onChange={handleChangePassword}
                    />
                    <Input
                        type={showPassword ? "text" : "password"}
                        autoComplete="false"
                        label="New Password"
                        placeholder=""
                        rightIcon={showPassword ? <EyeRevealed /> :  <EyeMasked />}
                        rightIconClicked={() => setShowPassword(!showPassword)}
                        rightIconClass="px-3"
                        name="password"
                        value={form.password}
                        onChange={handleChangePassword}
                    />
                    <Input
                        type={showPassword ? "text" : "password"}
                        autoComplete="false"
                        label="Confirm New Password"
                        placeholder=""
                        rightIcon={showPassword ? <EyeRevealed /> :  <EyeMasked />}
                        rightIconClicked={() => setShowPassword(!showPassword)}
                        rightIconClass="px-3"
                        name="confirmPassword"
                        value={form.confirmPassword}
                        onChange={handleChangePassword}
                    />                        
                </div>
                <div className="p-1 mt-4 flex justify-end space-x-3">
                    <button type="button" onClick={() => setIsOpen(false)} className="btn btn-lg rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white">
                        Cancel
                    </button>
                    <ButtonLoader type="submit" disabled={changePasswordLoading} className="btn btn-lg rounded-lg whitespace-nowrap border border-ep-primary-600 text-white bg-ep-primary-600">
                        Save Changes
                    </ButtonLoader>
                </div>
            </form>
        </FormDrawer>
  )
}

export default ChangePasswordModal